/**
 * @generated SignedSource<<49be6331948a2f689587383ca639558f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useWorkspaceSignalEditRemoveFileMutation$variables = {
  fileIds: ReadonlyArray<string>;
  signalWorkspaceId: string;
};
export type useWorkspaceSignalEditRemoveFileMutation$data = {
  readonly signalWorkspace: {
    readonly removeFiles: {
      readonly descriptionFiles: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalEditMainEditedInfo_Signal">;
    };
  };
};
export type useWorkspaceSignalEditRemoveFileMutation = {
  response: useWorkspaceSignalEditRemoveFileMutation$data;
  variables: useWorkspaceSignalEditRemoveFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "signalWorkspaceId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "signalWorkspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "fileIds",
    "variableName": "fileIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "descriptionFiles",
  "plural": true,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkspaceSignalEditRemoveFileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "removeFiles",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceSignalEditMainEditedInfo_Signal"
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useWorkspaceSignalEditRemoveFileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "removeFiles",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b621a25dfcf4b39b80c95b63e9c57b5d",
    "id": null,
    "metadata": {},
    "name": "useWorkspaceSignalEditRemoveFileMutation",
    "operationKind": "mutation",
    "text": "mutation useWorkspaceSignalEditRemoveFileMutation(\n  $signalWorkspaceId: ID!\n  $fileIds: [ID!]!\n) {\n  signalWorkspace(id: $signalWorkspaceId) {\n    removeFiles(fileIds: $fileIds) {\n      id\n      ...WorkspaceSignalEditMainEditedInfo_Signal\n      descriptionFiles {\n        id\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceSignalEditMainEditedInfo_Signal on SignalWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "a84a76b79a71232dba1863a0ae3cd26e";

export default node;
